<script>
export default {
  props: {
    locale: {
      type: String,
      required: true,
    },
  },
  computed: {
    flagIconClasses() {
      return ['fi', `fi-${this.locale.replace('en', 'gb')}`]
    },
  },
}
</script>
<template>
  <i :class="flagIconClasses"></i>
</template>
